<template>
  <div>
    <AssetableCover :asset="asset" />
  </div>
</template>

<script>
import AssetableCover from './AssetableCover.vue';

export default {
  components: {
    AssetableCover,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
};
</script>
